export default "__VITE_ASSET__f1fcb511__"